export default "__VITE_ASSET__DA6WqVl9__"